import React from 'react';
import styled from 'styled-components';
import Header from './Components/Header';
import { Trans, useTranslation } from 'react-i18next';
import { themeColor } from '../Theming';
import { eonImages } from '../Theming/images';
import { ANALYTICS_PAGE_NAMES } from '../Common/Analytics/utils';
import { usePageViewTracking } from '../Common/Hooks';
import { isAndroid } from 'react-device-detect';
import { onClose } from '../Common/KindredAndroidInterface/KindredAndroidInterface';

const Container = styled.div`
  flex: 1;
  flex-direction: column;
  display: flex;
  height: 100dvh;
  max-width: 600px;
  margin: 0 auto;
  padding-bottom: 30px;
`;

const Title = styled.div<{ $mainFontSize?: string; $subFontSize?: string }>`
  margin-top: 7vh;
  font-size: ${({ $subFontSize }) => ($subFontSize ? $subFontSize : '18px')};
  text-align: center;
  color: ${themeColor('white')};
  font-family: Helvetica;
  padding-inline: 10px;

  & p {
    text-align: center;
    color: ${themeColor('white')};
    font-size: ${({ $mainFontSize }) =>
      $mainFontSize ? $mainFontSize : '32px'};
    margin: 0;
    font-family: Helvetica;
    font-weight: 700;

    :last-child {
      margin-top: 5px;
      font-weight: 800;
    }
  }
`;

const MainContent = styled.div`
  padding-top: 130px;
  flex: 1;
  display: flex;
  flex-direction: column;

  & > button {
    background-color: ${themeColor('navyBlueText')};
    height: 56px;
    margin: 40px 35px 0 35px;
    border-radius: 100px;
    color: ${themeColor('white')};
    font-size: 16px;
    font-weight: 700;
    font-family: Helvetica;
    border: none;
  }

  & > img {
    width: 100vw;
    max-width: 600px;
  }

  & > a {
    text-decoration: underline;
    color: ${themeColor('textLink')};
    text-align: center;
    margin-top: 16px;
    font-size: 16px;
  }
`;

const EonPluginActivationStartShopping = () => {
  const { t } = useTranslation();
  const { activation_complete_page } = ANALYTICS_PAGE_NAMES;
  usePageViewTracking(activation_complete_page, 'Eon');

  const openEonApp = () => {
    if (isAndroid) {
      return onClose();
    }
    window.location.href = 'eonnext://KINDRED_RETURN';
  };

  return (
    <Container>
      <Header
        image={eonImages.eon_header_generic}
        height="25vh"
        titleContent={
          <Title
            $mainFontSize="min(37px, 8vw)"
            $subFontSize={window.screen.width > 380 ? '18px' : '16px'}
          >
            <Trans t={t} i18nKey="eon.addDone">
              <p />
            </Trans>
          </Title>
        }
      />
      <MainContent>
        <img src={eonImages.brands} alt="brand logos" />
        <button onClick={openEonApp}>{t('eon.backToApp')}</button>
        <a
          href="https://event.kindred.co/eonfaq"
          target="_blank"
          rel="noreferrer"
        >
          {t('eon.faq')}
        </a>
      </MainContent>
    </Container>
  );
};

export default EonPluginActivationStartShopping;
